module.exports = __webpack_public_path__ + "img/ANTENNA 1 PURPLE.933b3f9.svg";